export const USER_COOKIE_NAME = 'token';
export const ASSET_COOKIE_NAME = 'asset-token';
export const LOGGED_IN_COOKIE_NAME = 'logged-in';
export const ASSET_QUERY_PARAM = 'assetToken';
export const CSRF_COOKIE_NAME = '__Host-csrf-token'; // The __Host- prefix locks the cookie to the issuing domain
export const CSRF_FIELD_NAME = 'csrfToken';
export const OAUTH_STATE_COOKIE_NAME = 'oauthState';
export const CUSTOM_DOMAIN_COOKIE_PREFIX = 'custom-domain-token-';

// Max time to keep info about a given user's access to a given host
export const BUILD_ACCESS_EXPIRY = 30 * 60 * 1000; // <- 30 mins

export const USER_COOKIE_AGE = 30 * 24 * 60 * 60 * 1000; // 30 days in ms
export const IMPERSONATOR_COOKIE_AGE = 60 * 60 * 1000; // 1 hour in ms
